import { API_ENDPOINT } from 'env'

const authHeaders = () => {
  const parsed = JSON.parse(localStorage.getItem('state'))
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${parsed.auth.token}`,
  }
}

const handle = async (res) => {
  if (!res.ok) {
    const error = await res.json().catch(() => ({}))
    throw new Error(error.message || 'Erro na requisição')
  }
  return res.json()
}

export const getTitulos = async (filtros = {}) => {
  const qs = new URLSearchParams(
    Object.entries(filtros).filter(([, v]) => v !== undefined && v !== '' && v !== null),
  ).toString()
  const res = await fetch(`${API_ENDPOINT}/titulos-lbc?${qs}`, { method: 'GET', headers: authHeaders() })
  return handle(res)
}

export const criarTitulo = async (body) => {
  const res = await fetch(`${API_ENDPOINT}/titulos-lbc`, {
    method: 'post', headers: authHeaders(), body: JSON.stringify(body),
  })
  return handle(res)
}

export const editarTitulo = async (id, body) => {
  const res = await fetch(`${API_ENDPOINT}/titulos-lbc/${id}`, {
    method: 'put', headers: authHeaders(), body: JSON.stringify(body),
  })
  return handle(res)
}

export const excluirTitulo = async (id) => {
  const res = await fetch(`${API_ENDPOINT}/titulos-lbc/${id}`, { method: 'delete', headers: authHeaders() })
  return handle(res)
}

export const getSaldoCertificado = async ({ projetoId, anoBase }) => {
  const res = await fetch(
    `${API_ENDPOINT}/certificados-lbc/saldo?projetoId=${projetoId}&anoBase=${anoBase}`,
    { method: 'GET', headers: authHeaders() },
  )
  return handle(res)
}

export const getEmpresas = async () => {
  const res = await fetch(`${API_ENDPOINT}/certificados-lbc/empresas`, { method: 'GET', headers: authHeaders() })
  return handle(res)
}

// Certificado ativo do projeto/ano. O título herda dele o código e a ecorregião,
// então o formulário mostra a origem desses dados antes da emissão.
export const getCertificadoAtivo = async ({ projetoId, anoBase }) => {
  const res = await fetch(
    `${API_ENDPOINT}/certificados-lbc/ativo?projetoId=${projetoId}&anoBase=${anoBase}`,
    { method: 'GET', headers: authHeaders() },
  )
  return handle(res)
}
